// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pAQ73WxpW4SIHljhIa-UB","padding":"_3wZ6ECd-ha7hakcZFwMC5M","margin":"_24GsakAUrUrAk95DKuIbnb"};